import { render, staticRenderFns } from "./ProductCardTable.vue?vue&type=template&id=64062bdc"
import script from "./ProductCardTable.vue?vue&type=script&lang=js"
export * from "./ProductCardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports